export const GET_ALERT_SUCCESS = "GET_ALERT_SUCCESS";
export const GET_ALERT_FAIL = "GET_ALERT_FAIL";

export const GET_ALERT_ALL_SUCCESS = "GET_ALERT_ALL_SUCCESS";
export const GET_ALERT_ALL_FAIL = "GET_ALERT_ALL_FAIL";

export const GET_LATEST_ALERT_SUCCESS = "GET_LATEST_ALERT_SUCCESS";
export const GET_LATEST_ALERT_FAIL = "GET_LATEST_ALERT_FAIL";

export const GET_TOTAL_ALERTS_PER_MONTH_SUCCESS = "GET_TOTAL_ALERTS_PER_MONTH_SUCCESS";
export const GET_TOTAL_ALERTS_PER_MONTH_FAIL = "GET_TOTAL_ALERTS_PER_MONTH_FAIL";


export const GET_INCIDENTS_RATE_SUCCESS = "GET_INCIDENTS_RATE_SUCCESS";
export const GET_INCIDENTS_RATE_FAIL = "GET_INCIDENTS_RATE_FAIL";

export const GET_HIGHEST_ZONE_SUCCESS = "GET_HIGHEST_ZONE_SUCCESS";
export const GET_HIGHEST_ZONE_FAIL = "GET_HIGHEST_ZONE_FAIL";

export const GET_ALERT_WEEKLY_SUCCESS = "GET_ALERT_WEEKLY_SUCCESS";
export const GET_ALERT_WEEKLY_FAIL = "GET_ALERT_WEEKLY_FAIL";

export const GET_ARCH_ALERT_ALL_SUCCESS = "GET_ARCH_ALERT_ALL_SUCCESS";
export const GET_ARCH_ALERT_ALL_FAIL = "GET_ARCH_ALERT_ALL_FAIL";
